import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Vouchers } from '../../../../assets/js/com/ts_api_client';
import { StorageService } from '../../services/storage.service';

@Component({
    selector: 'bdo-wishvoucher',
    templateUrl: './wishvoucher.component.html',
    styleUrls: ['./wishvoucher.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WishvoucherComponent implements OnInit{
  @Input() vouchers: Vouchers;

  ngOnInit(): void {
    if (!this.vouchers) {
      this.vouchers = StorageService.getOfferVouchers();
    }
  };

}
